import { render } from "./Personalinformation.vue?vue&type=template&id=946e777c"
import script from "./Personalinformation.vue?vue&type=script&lang=js"
export * from "./Personalinformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__